import React from "react"
import { AiGlobalStats } from "../types/ai-dashboard"

interface Props {
     stats: AiGlobalStats
     isLoading: boolean // Added
}

const AiStatsGrid: React.FC<Props> = ({ stats, isLoading }) => {
     const Card = ({ title, value, colorClass = "" }: { title: string; value: string | number; colorClass?: string }) => (
          <div className="card border-0 shadow-sm h-100">
               <div className="card-body">
                    <h6 className="card-subtitle mb-2 text-muted fw-normal">{title}</h6>
                    {isLoading ? (
                         <div className="placeholder-glow">
                              <span className="placeholder col-8 rounded" style={{ height: "28px" }}></span>
                         </div>
                    ) : (
                         <h3 className={`card-title mb-0 fw-bold ${colorClass}`}>{value}</h3>
                    )}
               </div>
          </div>
     )

     return (
          <div className="row g-4 h-100">
               <div className="col-sm-6">
                    <Card title="Coût Total Estimé" value={`$${(stats.totalCost || 0).toFixed(2)}`} colorClass="text-primary" />
               </div>
               <div className="col-sm-6">
                    <Card title="Tokens Totaux" value={`${((stats.totalTokens || 0) / 1000).toFixed(1)}k`} />
               </div>
               <div className="col-sm-6">
                    <Card title="Économie Cache" value={`+${(stats.cachedTokens || 0).toLocaleString()}`} colorClass="text-success" />
               </div>
               <div className="col-sm-6">
                    <Card title="Documents Analysés" value={stats.documentsCount || 0} />
               </div>
          </div>
     )
}

export default AiStatsGrid
